{
  "login": {
    "title": "Sign In",
    "subtitle": "Enter your credentials to continue",
    "email": "Email",
    "password": "Password",
    "submit": "Sign In",
    "googleSignIn": "Continue with Google",
    "noAccount": "Don't have an account?",
    "signUpLink": "Sign Up",
    "signUpTitle": "Sign Up",
    "signUpSubtitle": "Create a new account",
    "signUpSubmit": "Sign Up",
    "hasAccount": "Already have an account?",
    "signInLink": "Sign In",
    "invalidCredentials": "Invalid email or password",
    "error": "Login failed. Please try again."
  },
  "common": {
    "welcome": "Welcome, {name}!",
    "loading": "Loading...",
    "save": "Save",
    "cancel": "Cancel",
    "delete": "Delete",
    "edit": "Edit",
    "close": "Close",
    "confirm": "Confirm",
    "error": "Error",
    "success": "Success"
  },
  "panel": {
    "header": "Role Details",
    "placeholder": "Click on a role to view details",
    "successMessage": "Child role created! Refreshing...",
    "details": {
      "purpose": "Purpose",
      "accountabilities": "Accountabilities",
      "responsibilities": "Responsibilities",
      "value": "Value",
      "noPurpose": "No purpose defined",
      "noAccountabilities": "No accountabilities defined",
      "noResponsibilities": "No responsibilities defined"
    },
    "tabs": {
      "details": "Role",
      "people": "People",
      "contained": "Contained",
      "referenced": "Referenced"
    },
    "edit": {
      "enterEditMode": "Edit",
      "saveChanges": "Save Changes",
      "cancelChanges": "Cancel",
      "saveHint": "Changes save on blur",
      "enterToSave": "Press Enter to save",
      "saveOnChange": "Saves on change"
    },
    "claim": {
      "claim": "Claim this role",
      "unclaim": "Unclaim",
      "claimedBy": "Claimed by you"
    },
    "create": {
      "addChild": "Add Child Role",
      "roleName": "Role Name",
      "create": "Create",
      "childName": "Child Name",
      "size": "Size",
      "color": "Color",
      "createButton": "Create Child",
      "creating": "Creating..."
    },
    "delete": {
      "deleteRole": "Delete Role",
      "confirmDelete": "Are you sure you want to delete this role?",
      "hasChildren": "This role contains {count} child roles. They will also be deleted."
    },
    "people": {
      "label": "People in this role",
      "noClaims": "No one has claimed this role yet",
      "since": "since {date}",
      "first": "first: {date}",
      "current": "current: {date}"
    },
    "referenced": {
      "label": "Referenced By",
      "none": "No roles reference this role"
    },
    "contained": {
      "label": "Contained Roles",
      "none": "No contained roles",
      "children": "Children"
    },
    "actions": {
      "viewMode": "← View Mode",
      "myRoles": "← My Roles"
    }
  },
  "search": {
    "placeholder": "Search roles...",
    "noResults": "No roles found matching \"{query}\"",
    "showMyRoles": "Show My Roles",
    "showAllRoles": "Show All Roles"
  },
  "settings": {
    "title": "Settings",
    "selectLanguage": "Select Language",
    "language": "Language",
    "theme": "Theme",
    "lightMode": "Light Mode",
    "darkMode": "Dark Mode"
  },
  "main": {
    "showMyRoles": "Show My Roles",
    "hideMyRoles": "Hide My Roles"
  },
  "hover": {
    "noPurpose": "No purpose",
    "accountabilities": "Accountabilities",
    "responsibilities": "Responsibilities",
    "none": "None"
  },
  "legend": {
    "toggleButton": "Legend",
    "noCustomColors": "No custom colors assigned",
    "showRolesWithData": "Show roles with data",
    "impressum": "Impressum",
    "privacy": "Privacy Policy"
  },
  "errors": {
    "updateFailed": "Update Failed",
    "createFailed": "Error Creating Node",
    "deleteFailed": "Delete Failed",
    "saveFailed": "Save Error",
    "cannotDelete": "Cannot Delete",
    "cannotDeleteMessage": "Cannot delete \"{name}\" because it contains child nodes.{childList}\n\nPlease delete or move the child nodes first.",
    "confirmDelete": "Are you sure you want to delete \"{name}\"?",
    "invalidInput": "Invalid Input",
    "pleaseEnterName": "Please enter a role name",
    "creationFailed": "Creation Failed",
    "createChildFailed": "Failed to create child role",
    "unknownError": "Unknown error",
    "childRolesList": "\n\nChild roles:\n• {children}",
    "referencedBy": "Referenced by:\n• {references}"
  },
  "myRoles": {
    "title": "My Roles",
    "noClaims": "You have not claimed any roles yet.",
    "loadingDetails": "Loading role details..."
  },
  "toast": {
    "roleDeleted": "Role deleted",
    "roleSaved": "Changes saved",
    "roleCreated": "Role created"
  }
}
